import React, { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Input } from './ui/input';

interface SearchDropdownProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  open: boolean;
  children: React.ReactNode;
}

const SearchDropdown: React.FC<SearchDropdownProps> = ({
  placeholder, value, onChange, className, open, children
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [style, setStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    if (!open) return;

    let frameId: number;
    const update = () => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const maxH = 208;

      if (spaceBelow < maxH) {
        setStyle({
          position: 'fixed',
          bottom: window.innerHeight - rect.top + 1,
          top: 'auto' as any,
          left: rect.left,
          width: rect.width,
          zIndex: 9999,
        });
      } else {
        setStyle({
          position: 'fixed',
          top: rect.bottom + 1,
          left: rect.left,
          width: rect.width,
          zIndex: 9999,
        });
      }
      frameId = requestAnimationFrame(update);
    };
    frameId = requestAnimationFrame(update);
    return () => cancelAnimationFrame(frameId);
  }, [open]);

  return (
    <div ref={containerRef} className="relative mb-2">
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={className}
      />
      {open && createPortal(
        <div
          dir="rtl"
          style={style}
          className="bg-gray-900 border border-gray-700 rounded shadow-lg max-h-52 overflow-y-auto p-2"
        >
          {children}
        </div>,
        document.body
      )}
    </div>
  );
};

export default SearchDropdown;
